<wiz-h-divider width="100%" height="100%" gap="0">
  <wiz-vgroup width="450px" height="100%">
    <multi-display #multiDisplay width="100%" height="100%" [config]="multiConfig">
      <wiz-hgroup target="icons">
        <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-purple"
          (click)="doAct('export')">download</wiz-icon>
        <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-purple"
          (click)="doAct('import')">upload</wiz-icon>
        <!-- <wiz-icon [wizTooltip]="'$.common.import.$'" class="image-purple" (click)="doAct('importArgs')" >settings</wiz-icon> -->
        <wiz-icon #btnDelete class="image-purple" [wizTooltip]="'$.common.delete.$'"
          (click)="doAct('delete')">delete</wiz-icon>
      </wiz-hgroup>

      <wiz-vgroup target="title">
        <wiz-hgroup verticalAlign="center" gap="10">
          <wiz-icon #btnCreate [wizTooltip]="'$.freedata.create.$'" tooltipPlacement="right" class="image-back-orange"
            (click)="doAct('create')">add</wiz-icon>
          <wiz-label class="titleLabel" [wizLabel]="'$.freedata.create.$'" [wizTextBehavior]="'truncate'"
            width="100%"></wiz-label>
        </wiz-hgroup>
        <wiz-button class="hyperButton" [wizLabel]="'$.common.create.from.model.$'"></wiz-button>
      </wiz-vgroup>
    </multi-display>
  </wiz-vgroup>

  <wiz-group width="100%" minWidth="600px" height="100%">
    <!-- Groupe de présentation lorsque pas de sélection -->
    <wiz-vgroup class="section-container-parent" #vgNoFreeData [visible]="!showEditionZone" height="100%" width="100%"
      gap="10">
      <widget-renderer class="view-widget" [title]="'$.freedata.title.$'"
        [description]="'$.freedata.home.description.$'">
      </widget-renderer>

      <wiz-vgroup width="100%" height="100%" class="section-container">
        <!-- modèles tout prêt -->
        <wiz-vgroup width="100%" height="100%">
          <multi-display code="FDSampleMD" #examplesMultiDisplay width="100%" height="100%"
            [config]="examplesMultiConfig">
            <wiz-hgroup target="title" width="100%">
              <wiz-label class="titleLabel" [wizLabel]="'$.common.example.title.$'"></wiz-label>
            </wiz-hgroup>
          </multi-display>
        </wiz-vgroup>

        <wiz-vgroup width="100%" horizontalAlign="end" height="44px" verticalAlign="center" padding="0 10px 0">
          <wiz-button #btnUseExamples [wizLabel]="'$.freedata.explore.example.$'" [wizIcon]="'icon-arrow-right'"
            [iconPlacement]="'right'"></wiz-button>
        </wiz-vgroup>
      </wiz-vgroup>
    </wiz-vgroup>

    <!-- Groupe d'édition -->
    <wiz-vgroup #vgDetailZone [visible]="showEditionZone" width="100%" height="100%" gap="10">
      
      <!-- entête d'édition -->
      <wiz-hgroup wizValidationContainer #vgEdition width="100%" class="section-container" padding="10px" height="250px"
        minHeight="0px" gap="5" [horizontalAlign]="'space-between'">
        <wiz-vgroup width="100%">
          <wiz-hgroup #hgCodeLabel wizValidationContainer gap="30">
            <wiz-text-input class="upper-case-input" [wizPlaceholder]="'$.common.define.$'"
              [wizValidator]="uniqueCodeValidator()" #tiCode [wizLabel]="'$.freedata.shortcode.$'" width="160px"
              [wizShowErrors]="true" [wizMandatory]="true" [wizMaxChars]="50">
            </wiz-text-input>
            <wiz-text-input #tiExternalCode [wizLabel]="'$.freedata.externalcode.$'" width="160px"></wiz-text-input>
            <wiz-translation-basic #trsLabel wizValidator [wizPlaceholder]="'$.common.define.$'"
              [wizLabel]="'$.freedata.label.$'" width="160px" [wizShowErrors]="true" [wizMandatory]="true">
            </wiz-translation-basic>
            <wiz-datefield #dfStartDate wizValidator [wizShowErrors]="true" [wizPlaceholder]="'$.common.define.$'"
              [wizLabel]="'$.freedata.startdate.$'" [wizManualInput]="true">
            </wiz-datefield>
            <wiz-datefield #dfEndDate wizValidator [wizShowErrors]="true" [wizPlaceholder]="'$.common.define.$'"
              [wizLabel]="'$.freedata.enddate.$'" [wizManualInput]="true">
            </wiz-datefield>
          </wiz-hgroup>

          <wiz-hgroup width="100%" verticalAlign="center">
            <wiz-icon style="font-size: 20px;">formula</wiz-icon>
            <wiz-checkbox #cbKindMeasure wizLabel="$.freedata.kindmeasure.$"></wiz-checkbox>
            <wiz-spacer width="30px"></wiz-spacer>
            <wiz-icon style="font-size: 20px;">wizeoo</wiz-icon>
            <wiz-checkbox #cbKindWild wizLabel="$.freedata.kindwild.$"></wiz-checkbox>
            <wiz-spacer width="30px"></wiz-spacer>
            <wiz-label [visible]="!showSequenceMode" [wizLabel]="'$.freedata.datatype.$'" class="componentLabel"></wiz-label>
            <wiz-dropdown #ddlDatatype  [visible]="!showSequenceMode" wizValidator [wizDataProvider]="datatypeDS" [wizLabelField]="'trsLabel'"
              wizShowLabel="false" width="200px"></wiz-dropdown>
          </wiz-hgroup>

          <wiz-hgroup verticalAlign="center" width="100%" horizontalAlign="space-between">
            <wiz-hgroup>
              <wiz-translation-basic #trsDesc [wizTranslationMode]="'textarea'" [maxTranslation]="6"
                [wizLabel]="'$.freedata.description.$'" [wizPlaceholder]="'$.common.define.$'" width="315px"
                height="100px"></wiz-translation-basic>
              <wiz-spacer width="30px"></wiz-spacer>
              <wiz-vgroup gap="0" height="100%" [visible]="!showSequenceMode">
                <wiz-label [wizLabel]="'$.freedata.image.$'" class="componentLabel"></wiz-label>
                <wiz-image #uploadFD tabindex="0" height="50px" class="img-picker" [useHandCursor]="true"
                  (click)="clickForUpload('FD')" (keydown)="keydownForUpload($event,'FD')"></wiz-image>
              </wiz-vgroup>
              <wiz-icon [visible]="hasImage('FD')" style="cursor: pointer; font-size: 20px" (click)="clearImage('FD')"
                [wizTooltip]="'$.common.delete.$'">delete</wiz-icon>

              <wiz-vgroup gap="0" width="200px" height="100%">
                <wiz-text-input #tiDefaultValue [visible]="!showSequenceMode" [wizLabel]="'$.arg.valor.$'" [wizMaxChars]="255"
                  width="200px"></wiz-text-input>

                <wiz-text-input #tiDefaultTrigger [visible]="!showSequenceMode" [wizLabel]="'$.arg.valor.trigger.$'" [wizMaxChars]="255"
                  width="200px"></wiz-text-input>
              </wiz-vgroup>

            </wiz-hgroup>

            <wiz-vgroup padding="3px" horizontalAlign="center">
              <wiz-button #btnSave [wizIcon]="'arrow-right'" [iconPlacement]="'right'" width="240px"></wiz-button>
              <wiz-button #btnCancel class="cancel-button" [wizIcon]="'arrow-left'"
                [wizLabel]="'$.common.cancel.modification.$'"></wiz-button>

              <wiz-hgroup verticalAlign="center" gap="10" [visible]="!showSequenceMode">
                <wiz-icon #btnShowMoreArgs [wizTooltip]="'$.freedata.moreargs.$'" class="image-back-orange"
                  (click)="doAct('moreArgs')">settings</wiz-icon>
                <wiz-label #lblMoreDetail class="smallTitleLabel" [wizLabel]="moreAgrsLabel"
                  [wizTextBehavior]="'truncate'" (click)="doAct('moreArgs')" width="100%"></wiz-label>
              </wiz-hgroup>

            </wiz-vgroup>
          </wiz-hgroup>
        </wiz-vgroup>
      </wiz-hgroup>

      <!-- zone de détail de l'édition -->
      <wiz-vgroup width="100%" height="100%" class="section-container-parent">
        <!-- visible lors de la création -->
        <wiz-vgroup width="100%" height="100%" class="section-container" padding="10px"
          [visible]="!showDetailZone && !moreArgsMode && !showSequenceMode">
          <wiz-label class="titleLabel" [wizLabel]="'$.freedata.values.title.$'"></wiz-label>
          <wiz-label [wizLabel]="'$.freedata.values.description.$'"></wiz-label>
        </wiz-vgroup>

        <!-- visible uniquement pour les séquence -->
        <wiz-vgroup width="100%" class="section-container" padding="10px"
        [visible]="showSequenceMode">
        <wiz-label class="titleLabel" [wizLabel]="'$.freedata.sequence.title.$'"></wiz-label>
        <wiz-label [wizLabel]="'$.freedata.sequence.description.$'"></wiz-label>
        </wiz-vgroup>


        <!-- gestion des champs complémentaires -->
        <wiz-vgroup wizValidationContainer #vgFDArgsEdition width="100%" height="100%" class="section-container"
          padding="5px" [visible]="moreArgsMode && !showSequenceMode" gap="10">

          <wiz-hgroup width="100%" height="100%">
            <multi-display #argsMultiDisplay code="argsMultiDisplay" width="100%" height="100%"
              [config]="argsMultiConfig">
              <wiz-vgroup target="title" width="100%">
                <wiz-hgroup verticalAlign="center" width="100%" style="padding-bottom: 10px;">
                  <wiz-icon [wizTooltip]="'$.freedata.args.add.$'" class="image-back-orange" (click)="newArgs()"
                    [wizDisabled]="cantCreateValues">add</wiz-icon>
                  <wiz-label class="titleLabel" [wizLabel]="'$.freedata.args.add.$'" [wizTextBehavior]="'truncate'"
                    width="100%"></wiz-label>
                  <wiz-icon class="image-purple" [wizTooltip]="'$.common.delete.$'" (click)="doAct('deleteArgs')"
                    [wizDisabled]="!showArgDelete">delete</wiz-icon>
                </wiz-hgroup>
              </wiz-vgroup>

            </multi-display>

            <!--  zone de détail des args -->
            <wiz-vgroup #vgEditArgs wizValidationContainer width="350px" padding="10px" height="100%"
              [visible]="showArgsEditZone" style="overflow: auto">
              <wiz-text-input class="upper-case-input" [wizPlaceholder]="'$.common.define.$'" #tiArgShortCode
                wizDisabled="true" [wizLabel]="'$.arg.code.$'" width="100%" [wizMaxChars]="50"></wiz-text-input>

              <wiz-translation-basic #trsArgLabel wizValidator [wizLabel]="'$.arg.label.$'" width="100%"
                [wizShowErrors]="true" [wizMandatory]="true"></wiz-translation-basic>

              <wiz-dropdown #ddlArgDatatype wizValidator width="100%" [wizDataProvider]="argsDatatypeDS"
                [wizLabelField]="'trsLabel'" [wizMandatory]="true" [wizLabel]="'$.arg.datatype.$'"></wiz-dropdown>

              <wiz-dropdown #ddlArgFormat wizValidator width="100%" [wizDataProvider]="argsFormatDS"
                [wizLabelField]="'trsLabel'" [wizLabel]="'$.arg.format.$'"></wiz-dropdown>

              <wiz-text-area [wizMaxChars]="255" #tiArgRestrict [wizLabel]="'$.arg.restrict.$'"
                width="100%"></wiz-text-area>

                <wiz-hgroup>
                  <wiz-text-input [wizMaxChars]="255" #tiRegex [wizLabel]="'$.arg.textrestrict.$'"
                    width="100%"></wiz-text-input>
                  <wiz-checkbox #cbUpper wizLabel="$.arg.uppercase.$"></wiz-checkbox>

                </wiz-hgroup>

              <wiz-hgroup>
                <wiz-text-input [wizMaxChars]="15" #tiMinVal [wizLabel]="'$.arg.minval.$'"
                  width="100%"></wiz-text-input>
                <wiz-text-input [wizMaxChars]="15" #tiMaxVal [wizLabel]="'$.arg.maxval.$'"
                  width="100%"></wiz-text-input>
              </wiz-hgroup>

              <wiz-text-area [wizMaxChars]="255" #tiArgLock [wizLabel]="'$.arg.lock.$'"
                width="100%"></wiz-text-area>

              <wiz-translation-basic #trsRestrictMsg wizValidator [wizLabel]="'$.arg.restrict.msg.$'" width="100%"
                [wizShowErrors]="false" [wizMandatory]="false"></wiz-translation-basic>

              <wiz-text-area [wizMaxChars]="255" #tiArgValidator [wizLabel]="'$.arg.validator.$'"
                width="100%"></wiz-text-area>

              <wiz-translation-basic #trsValueControlMsg wizValidator [wizLabel]="'$.arg.valuecontrol.msg.$'"
                width="100%" [wizShowErrors]="true" [wizMandatory]="false"></wiz-translation-basic>

              <wiz-text-input [wizMaxChars]="255" #tiArgSource [wizLabel]="'$.arg.source.$'"
                width="100%"></wiz-text-input>

              <wiz-text-input #tiArgDefaultValue [wizLabel]="'$.arg.valor.$'" [wizMaxChars]="255"
                width="100%"></wiz-text-input>

              <wiz-text-input #tiArgDefaultTrigger [wizLabel]="'$.arg.valor.trigger.$'" [wizMaxChars]="255"
                width="100%"></wiz-text-input>

              <wiz-text-input [wizMaxChars]="255" #tiArgAction [wizLabel]="'$.arg.action.$'"
                width="100%"></wiz-text-input>

              <wiz-numeric-input #niArgSize [wizLabel]="'$.arg.size.$'" allowNegative="false" nbDecimal="0"
                wizMaxNumber="300" width="100%"></wiz-numeric-input>

              <wiz-text-area
                #taArgSettings
                [wizLabel]="'$.mesure.settings.$'"
                width="100%"
                height="80px"
                [wizMaxChars]="2000"
              ></wiz-text-area>

            </wiz-vgroup>


          </wiz-hgroup>
        </wiz-vgroup>

        <!-- tryptique d'édition des FDVs -->
        <wiz-hgroup wizValidationContainer #vgFDVEdition height="100%" class="section-container xscroller" padding="5px"
          [visible]="showDetailZone && !showSequenceMode" gap="10">
          <!-- tree de présentation des freedata values -->
          <wiz-vgroup #vgTreeContainer width="400px" height="100%">
            <wiz-hgroup verticalAlign="center">
              <wiz-icon [wizTooltip]="'$.freedata.values.add.$'" class="image-back-orange" (click)="addFirstLevelFDV()"
                [wizDisabled]="cantCreateValues">add</wiz-icon>
              <wiz-label class="titleLabel" [wizLabel]="'$.freedata.values.add.$'" [wizTextBehavior]="'truncate'"
                width="100%"></wiz-label>
            </wiz-hgroup>
            <wiz-tree #treeFreeDataValues [actionsRenderer]="valuesTreeRenderer" width="100%" height="100%">
            </wiz-tree>
            <!-- filtre du tree -->
            <filter-component #fdValuesFilter width="250px"> </filter-component>
          </wiz-vgroup>

          <!--  zone de détail des FDVs -->
          <wiz-vgroup width="280px" height="100%" gap="0">
            <wiz-vgroup width="100%" height="100%" [visible]="!showFDVEditZone" padding="10px">
              <wiz-label class="smallTitleLabel" [wizLabel]="'$.freedata.values.title.$'"></wiz-label>
              <wiz-label [wizLabel]="'$.freedata.addvalues.description.$'"></wiz-label>
            </wiz-vgroup>
            <wiz-vgroup #vgEditValue wizValidationContainer width="100%" padding="10px" height="100%"
              [visible]="showFDVEditZone" style="overflow: auto">
              <wiz-hgroup width="100%">
                <wiz-text-input #tiValueCode [wizLabel]="'$.freedatavalue.code.$'" wizDisabled="true"
                  width="100%"></wiz-text-input>
                <wiz-icon [wizTooltip]="'$.common.edit.$'" class="image-purple" [visible]="!fdvExist()"
                  (click)="doAct('updateFDVCode')">edit</wiz-icon>
              </wiz-hgroup>


              <wiz-text-input class="upper-case-input" [wizValidator]="uniqueShortCodeValidator()" #tiValueShortCode
                [wizLabel]="'$.freedatavalue.shortcode.$'" [wizShowErrors]="true" width="100%" [wizMandatory]="true"
                [wizMaxChars]="50">
              </wiz-text-input>
              <wiz-translation-basic #trsValueLabel wizValidator [wizLabel]="'$.freedatavalue.label.$'" width="100%"
                [wizShowErrors]="true" [wizMandatory]="true"></wiz-translation-basic>

              <wiz-translation-basic #trsValueDesc [wizTranslationMode]="'textarea'"
                [wizLabel]="'$.freedatavalue.description.$'" width="100%" height="100px">
              </wiz-translation-basic>

              <wiz-text-input #tiValueExternalCode [wizLabel]="'$.freedatavalue.externalcode.$'"
                width="160px"></wiz-text-input>
              <wiz-text-input #tiValueExternalParentCode [wizLabel]="'$.freedatavalue.externalparentcode.$'"
                width="160px"></wiz-text-input>
              <wiz-text-input #tiValueValue [wizLabel]="'$.freedatavalue.value.$'" width="160px"></wiz-text-input>
              <wiz-hgroup width="100%" style="padding-top: 15px">
                <wiz-datefield #dfValueStartDate wizValidator [wizLabel]="'$.freedatavalue.startdate.$'"
                  [wizManualInput]="true" [wizShowErrors]="true" width="50%">
                </wiz-datefield>
                <wiz-datefield #dfValueEndDate wizValidator [wizLabel]="'$.freedatavalue.enddate.$'"
                  [wizManualInput]="true" [wizShowErrors]="true" width="50%">
                </wiz-datefield>
              </wiz-hgroup>

              <wiz-hgroup>
                <wiz-vgroup gap="0" style="overflow: unset">
                  <wiz-label [wizLabel]="'$.freedatavalue.image.$'" class="componentLabel"></wiz-label>
                  <wiz-image #uploadFDV tabindex="0" class="img-picker" (click)="clickForUpload('FDV')"
                    (keydown)="keydownForUpload($event,'FDV')" height="50px" width="50px" [useHandCursor]="true">
                  </wiz-image>
                </wiz-vgroup>
                <wiz-icon #clearFDV [visible]="hasImage('FDV')" style="cursor: pointer; font-size: 20px"
                  (click)="clearImage('FDV')" [wizTooltip]="'$.common.delete.$'">delete</wiz-icon>
              </wiz-hgroup>

              <wiz-text-area [wizMaxChars]="255" #tiValueRestrict [wizLabel]="'$.arg.restrict.$'"
                width="100%"></wiz-text-area>
 
              <wiz-numeric-input #niOrder [wizLabel]="'$.common.order.$'" allowNegative="true" nbDecimal="0"
                   width="100%"></wiz-numeric-input>

              <wiz-checkbox #cbValueDeprecated wizLabel="$.common.deprecated.$"></wiz-checkbox>



            </wiz-vgroup>
          </wiz-vgroup>

          <!-- Zone de saisie des informations complémentaires -->
          <wiz-vgroup #vgFDVArgs [visible]="showFDVEditZone && fdArgs" wizValidationContainer width="280px"
            height="100%" gap="0">
            <wiz-hgroup verticalAlign="center">
              <wiz-label class="titleLabel" [wizLabel]="'$.arg.feed.$'"></wiz-label>
            </wiz-hgroup>
            <wiz-vgroup width="100%" height="100%" style="overflow: auto">
              <ng-container #containerFdvArgs></ng-container>
            </wiz-vgroup>
          </wiz-vgroup>

          <!-- zone de gestion des libellés de niveaux -->
          <wiz-vgroup wizValidationContainer #vgFDLEdition width="200px" height="100%" class="sub-container">
            <wiz-hgroup verticalAlign="center">
              <wiz-label class="titleLabel" [wizLabel]="'$.freedata.values.levels.$'"></wiz-label>
            </wiz-hgroup>
            <wiz-vgroup width="100%" height="100%" style="overflow: auto"><ng-container #containerLevels></ng-container>
            </wiz-vgroup>
          </wiz-vgroup>
        </wiz-hgroup>
      </wiz-vgroup>
    </wiz-vgroup>
  </wiz-group>
</wiz-h-divider>